if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.isLoaded = false;
    }
  
    connectedCallback() {
      this.initializeIntersectionObserver();
    }
  
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  
    initializeIntersectionObserver() {
      const options = {
        rootMargin: '0px 0px 200px 0px',
        threshold: 0
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
      this.observer.observe(this);
    }
  
    handleIntersection(entries) {
      const entry = entries[0];
      if (!entry.isIntersecting || this.isLoaded) return;
  
      this.observer.unobserve(this);
      this.loadRecommendations();
    }
  
    async loadRecommendations() {
      const url = this.dataset.url;
      if (!url) return;
  
      try {
        const response = await fetch(url);
        const text = await response.text();
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
  
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.isLoaded = true;
        }
      } catch (error) {
        console.error('Failed to load product recommendations:', error);
      }
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);
}